import styled from "@emotion/styled"
import { spacingStaticXs, spacingStaticSm, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "../../../skeleton"

interface ColorRadioGroupSkeletonProps {
	className?: string
	count: number
}

export const ColorRadioGroupSkeleton = ({ className, count }: ColorRadioGroupSkeletonProps) => (
	<Wrapper className={className}>
		<Skeleton.Text $width="25%" />
		<Layout>
			{Array.from({ length: count }, (_, i) => (
				<StyledSkeletonCheckbox key={i} />
			))}
		</Layout>
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
`

const StyledSkeletonCheckbox = styled(Skeleton.Checkbox)`
	width: 120px;
`

const Layout = styled.div`
	display: grid;
	gap: ${spacingStaticSm} ${spacingStaticLg};
	grid-template-columns: repeat(auto-fill, minmax(15em, 1fr));
`
